const LETTER_COMBINATION_GROUPS = {
  LONG_A_DIGRAPHS: ['ai', 'aigh', 'ay', 'ea', 'ei', 'eigh', 'ey'],
  LONG_E_DIGRAPHS: ['ea', 'ee', 'ei', 'ey', 'ie'],
  LONG_I_DIGRAPHS: ['ie', 'igh', 'ui', 'uy', 'ye'],
  LONG_O_DIGRAPHS: ['oa', 'oe', 'ow'],
  ODD_DIGRAPHS: ['au', 'aw', 'ea', 'ee', 'ew', 'ie', 'oa', 'oo', 'ou', 'ue', 'ui'],
  DIPHTHONGS: ['oi', 'oy', 'ou', 'ow'],
  R_CONTROLLED_VOWELS: ['ar', 'er', 'ir', 'or', 'ur'],
  ODD_R_CONTROLLED_VOWELS: ['or', 'ar'],
  OTHER_ODDBALLS: ['igh', 'ough', 'augh'],
  CONSONANT_DIGRAPHS: ['ch', 'ck', 'gh', 'gn', 'kn', 'ph', 'mb', 'ng', 'sh', 'tch', 'th', 'wh', 'wr', 'qu'],
  DOUBLES: ['bb', 'dd', 'ff', 'gg', 'll', 'mm', 'nn', 'pp', 'ss', 'tt', 'zz'],
  INFLECTIONAL_ENDINGS: ['ing', 'ed'],
  PREFIXES: ['de', 'dis', 'il', 'im', 'in', 'ir', 'mis', 'non', 're', 'un'],
  SUFFIXES: [
    'able',
    'ative',
    'ed',
    'er',
    'es',
    'ful',
    'ible',
    'ing',
    'ion',
    'itive',
    'ive',
    'ly',
    'ment',
    'or',
    'sion',
    'tion',
  ],
};

const LETTER_COMBINATION_GROUP_SUBTITLES = {
  LONG_A_DIGRAPHS: 'Long A Digraphs',
  LONG_E_DIGRAPHS: 'Long E Digraphs',
  LONG_I_DIGRAPHS: 'Long I Digraphs',
  LONG_O_DIGRAPHS: 'Long O Digraphs',
  ODD_DIGRAPHS: 'Odd Digraphs',
  DIPHTHONGS: 'Diphthongs',
  R_CONTROLLED_VOWELS: 'R-Controlled Vowels',
  ODD_R_CONTROLLED_VOWELS: 'Odd R-Controlled Vowels',
  OTHER_ODDBALLS: 'Other Oddballs',
  CONSONANT_DIGRAPHS: 'Consonant Digraphs',
  DOUBLES: 'Doubles',
  INFLECTIONAL_ENDINGS: 'Inflectional Endings',
  PREFIXES: 'Prefixes',
  SUFFIXES: 'Suffixes',
};

const letterCombinations = {};

Object.keys(LETTER_COMBINATION_GROUPS).forEach((letterCombinationGroup) => {
  LETTER_COMBINATION_GROUPS[letterCombinationGroup].forEach((letterCombination) => {
    const id = `${letterCombinationGroup}_${letterCombination}`;

    letterCombinations[id] = {
      id,
      letter: letterCombination,
      title: letterCombination,
      subtitle: LETTER_COMBINATION_GROUP_SUBTITLES[letterCombinationGroup],
      type: 'LETTER_COMBINATION',
      pattern: letterCombinationGroup,
      fontFamily: 'Greycliff',
      colorHex: '#000',
      dropShadow: false,
    };
  });
});

// Add orange letters for some long o digraphs
const LONG_O_DIGRAPHS_ORANGE = ['oa', 'oe', 'ow'];
LONG_O_DIGRAPHS_ORANGE.forEach((letterCombination) => {
  const id = `LONG_O_DIGRAPHS_${letterCombination}_ORANGE`;

  letterCombinations[id] = {
    id,
    letter: letterCombination,
    title: letterCombination,
    subtitle: 'Long O Digraphs',
    type: 'LETTER_COMBINATION',
    pattern: 'LONG_O_DIGRAPHS',
    fontFamily: 'Greycliff',
    colorHex: '#FD7E14',
    dropShadow: false,
  };
});

export default letterCombinations;
